import React from 'react';
const badges = ['VISA', 'Mastercard', 'AMEX', 'PayPal'];

/** Row of accepted-payment method badges. */
export function PaymentBadges() {
  return <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-134" data-mp="2mg0lahvm8ij4">
      {badges.map(b => <span key={b} className="rounded-md border border-cream-deep bg-white px-3 py-1.5 text-xs font-bold tracking-wide text-ink/70 shadow-sm" data-id="element-135" data-mp="3192sh1bo68j1">
          {b}
        </span>)}
    </div>;
}